import {
    Box,
    Typography,
    IconButton,
    Grid,
    useTheme,
    useMediaQuery,
} from '@mui/material'
import {
    KeyboardArrowLeft,
    KeyboardArrowRight,
} from '@mui/icons-material'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';

import LinkRouter from '../../../components/LinkRouter';

import { home_page_main, home_page_main_small, partner_1, partner_2, partner_3 } from '../../../assets/backgrounds';
import { audit_outlined, read_outlined, team_outlined } from '../../../assets/icons';

import { MoreInfoButtonStyle, MVBoxStyle } from './styled';
import Chronology from './chronology';
import Contacts from './contacts';
import Reporting from './reportingSmall';
import TeamCarousel from '../AboutUs/team';
import ChronologyTablet from './chronologyTablet';
import ChronologyPhone from './ChronologyPhone';
import HideForms from '../../../components/SendPulseForms/hide';



const HomePage = () => {
    const { palette } = useTheme();
    const theme = useTheme();

    const navigate = useNavigate();

    const isXl = useMediaQuery(theme.breakpoints.only("xl"));
    const isLg = useMediaQuery(theme.breakpoints.only("lg"));
    const isMd = useMediaQuery(theme.breakpoints.only("md"));
    const isXs = useMediaQuery(theme.breakpoints.down("md"));

    const [partners, setPartners] = useState<Array<string>>([]);

    useEffect(() => {
        document.title = `About Ukraine`;

        let tempArr: Array<string> = [];
        for (let i = 0; i < 12; i++) {
            tempArr.push(`/assets/backgrounds/partners/${i + 1}.png`);
        }
        setPartners(tempArr)
    }, [])


    return (
        <>
            <HideForms />
            <Grid container spacing={0} columns={{ xs: 4, md: 5, lg: 12 }} sx={{ mt: { xs: "28px", md: "50px", lg: "70px" }, mb: { xs: "40px", lg: "153px" } }}>
                <Grid item xs={4} md={5} lg={12} sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
                    <Box sx={{ width: { xs: "100%", md: "380px", lg: "870px" }, mt: { md: "28px", lg: "33px" } }}>
                        <Typography variant="h1" fontFamily="Druk Wide, sans-serif" fontWeight="bold" fontSize={{ xs: "28px", lg: "50px" }} lineHeight={{ xs: "38px", lg: "62px" }} >
                            Об’єднані культурою - творимо історію
                        </Typography>
                        <Typography
                            variant="h3"
                            fontFamily="Fixel Display, sans-serif"
                            color="text.secondary"
                            sx={{
                                fontSize: { xs: "14px", md: "h5.fontSize", lg: "h3.fontSize" },
                                lineHeight: { xs: "22px", lg: "32px" },
                                mt: { xs: "8px", lg: "34px" }
                            }}
                        >
                            Реалізуємо проєкти, які залучають молодь до пізнання української культури та допомагають формувати свідоме демократичне суспільство. Культура для нас — це основа об’єднання та розвитку.
                        </Typography>
                        <MoreInfoButtonStyle sx={{ mt: { xs: "16px", md: "34px" } }} onClick={() => { navigate("announcements"); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
                            Наші заходи тут
                        </MoreInfoButtonStyle>
                    </Box>
                    <Box sx={{ width: { xs: "337px", lg: "418px" }, height: { xs: "362px", lg: "449px" }, mt: { xs: "28px", md: "0px" }, mx: { xs: "auto", md: "0px" } }}>
                        <img
                            loading="eager"
                            src={(isMd || isXs) ? home_page_main_small : home_page_main}
                            alt="home_page_main"
                            style={{ width: "inherit", height: "inherit" }}
                        />
                    </Box>
                </Grid>
                {/* Про нас */}
                <Grid item xs={4} md={5} lg={12} sx={{ mt: { xs: "78px", lg: "106px" } }}>
                    <Typography variant="h2" fontFamily="Druk Wide, sans-serif" fontWeight="bold" fontSize={{ xs: "26px", md: "24px", lg: "36px" }} lineHeight="38px">
                        Про нас
                    </Typography>
                    <Typography variant="h4" fontFamily="Fixel Display, sans-serif" color="text.secondary" sx={{ fontSize: { xs: "h5.fontSize", lg: "h4.fontSize" }, mt: { xs: "14px", lg: "34px" } }}>
                        Про тебе і Україну — це громадська організація, заснована в листопаді 2022 року, яка працює над розвитком демократичного суспільства через популяризацію та збереження української культури
                    </Typography>
                    <Typography variant="h4" fontFamily="Fixel Display, sans-serif" color="text.secondary" sx={{ fontSize: { xs: "h5.fontSize", lg: "h4.fontSize" }, mt: { xs: "8px", lg: "20px" } }}>
                        Ми реалізуємо свою діяльність у понад п’яти областях України, залучаючи молодь до неформальної освіти, культурно-просвітницьких заходів і творчих ініціатив. Наші інтерактивні проєкти поєднують історичний контекст із сучасними мультимедійними форматами, що допомагає глибше зрозуміти суспільні процеси та їхній вплив на сьогодення.
                    </Typography>
                    <Box sx={{ display: "flex", justifyContent: "end", mt: { xs: "28px", md: "5px", lg: "20px" } }}>
                        <MoreInfoButtonStyle onClick={() => { navigate("about-us"); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
                            Дізнатися більше
                        </MoreInfoButtonStyle>
                    </Box>
                </Grid>
                {/* Наша місія/візія */}
                <Grid item xs={4} md={5} lg={12} sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", mt: { xs: "43px", lg: "120px" } }}>
                    <MVBoxStyle
                        onClick={() => { navigate("about-us"); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                    >
                        <Typography
                            variant="h2"
                            fontFamily="Druk Wide, sans-serif"
                            fontWeight="bold"
                            fontSize={{ xs: "22px", md: "18px", lg: "36px" }}
                            lineHeight="38px"
                            sx={{
                                pt: { xs: "6px", lg: "21px" },
                                px: { xs: "8px", md: "16px", lg: "22px" }
                            }}
                        >
                            Наша місія
                        </Typography>
                        <Typography
                            variant="h4"
                            fontFamily="Fixel Display, sans-serif"
                            sx={{
                                fontSize: { xs: "h5.fontSize", lg: "h4.fontSize" },
                                lineHeight: { xs: "22px", lg: "28px" },
                                pt: { xs: "0px", lg: "14px" },
                                px: { xs: "8px", md: "16px", lg: "22px" },
                                pr: { xs: "25px", md: "36px", lg: "0px" },
                            }}
                        >
                            Сприяти залученню молоді до пізнання та розвитку української культури, демонструючи її ключову роль у формуванні демократичного суспільства.
                        </Typography>
                        <IconButton
                            className="icon-button"
                            disableRipple
                            size="large"
                            sx={{
                                position: "absolute",
                                right: { xs: "12px", lg: "28px" },
                                bottom: { xs: "12px", lg: "14px" },
                                border: `2px solid #fff`,
                                p: "0px"
                            }}
                        >
                            <KeyboardArrowRight fontSize="inherit" />
                        </IconButton>
                    </MVBoxStyle>
                    <MVBoxStyle
                        sx={{ mt: { xs: "14px", md: "0px" } }}
                        onClick={() => { navigate("about-us"); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                    >
                        <Typography
                            variant="h2"
                            fontFamily="Druk Wide, sans-serif"
                            fontWeight="bold"
                            fontSize={{ xs: "22px", md: "18px", lg: "36px" }}
                            lineHeight="38px"
                            sx={{
                                pt: { xs: "6px", lg: "21px" },
                                px: { xs: "8px", md: "16px", lg: "22px" }
                            }}
                        >
                            Наша візія
                        </Typography>
                        <Typography
                            variant="h4"
                            fontFamily="Fixel Display, sans-serif"
                            sx={{
                                fontSize: { xs: "h5.fontSize", lg: "h4.fontSize" },
                                lineHeight: { xs: "22px", lg: "28px" },
                                pt: { xs: "0px", lg: "14px" },
                                px: { xs: "8px", md: "16px", lg: "22px" },
                                pr: { xs: "25px", md: "36px", lg: "0px" },
                            }}
                        >
                            Свідоме українське суспільство, в якому кожен розуміє значення культурної та історичної спадщини, активно зберігає й передає їх майбутнім поколінням.
                        </Typography>
                        <IconButton
                            className="icon-button"
                            disableRipple
                            size="large"
                            sx={{
                                position: "absolute",
                                right: { xs: "12px", lg: "28px" },
                                bottom: { xs: "12px", lg: "14px" },
                                border: `2px solid #fff`,
                                p: "0px"
                            }}
                        >
                            <KeyboardArrowRight fontSize="inherit" />
                        </IconButton>
                    </MVBoxStyle>
                </Grid>
                {/* Наша діяльність */}
                {/* lg */}
                <Grid item lg={8} sx={{ display: { xs: "none", lg: "block" }, mt: "128px" }}>
                    <Typography variant="h2" fontFamily="Druk Wide, sans-serif" fontWeight="bold" fontSize="36px" lineHeight="38px">
                        Наша діяльність
                    </Typography>
                    <Typography variant="h5" fontFamily="Fixel Display, sans-serif" color="text.secondary" sx={{ pt: "16px" }}>
                        Ми проводимо навчальні сесії та тренінги, спрямовані на підвищення обізнаності про українську<br />культуру, історію, а також на розвиток навичок, необхідних для підтримки та просування українських<br />інтересів у світі. Наші тренінги допомагають учасникам глибше зрозуміти<br />українські реалії та набути знань.
                    </Typography>
                </Grid>
                <Grid item lg={4} sx={{ display: { xs: "none", lg: "block" }, mt: "128px" }}>
                    <Box
                        sx={{
                            width: "394px",
                            height: "137px",
                            background: (theme) => theme.palette.text.secondary,
                            border: (theme) => `1px solid ${theme.palette.text.primary}`,
                            borderRadius: "8px",
                            display: "flex"
                        }}
                    >
                        <Box sx={{ width: "40px", height: "40px", pt: "7px", pl: "11px" }}>
                            <img
                                loading="eager"
                                style={{ width: "inherit", height: "inherit" }}
                                src={audit_outlined}
                                alt="audit_outlined"
                            />
                        </Box>
                        <Typography
                            variant="h3"
                            fontFamily="Fixel Display, sans-serif"
                            fontWeight={600}
                            fontSize="24px"
                            lineHeight="24px"
                            textTransform="uppercase"
                            sx={{
                                color: (theme) => theme.palette.background.default,
                                alignContent: "center",
                                p: "7px 15px 7px 20px",
                            }}
                        >
                            Збереження та популяризація української культурної спадщини
                        </Typography>
                    </Box>
                </Grid>
                <Grid item lg={4} sx={{ display: { xs: "none", lg: "block" } }} />
                <Grid item lg={4} sx={{ display: { xs: "none", lg: "flex" }, justifyContent: "center" }}>
                    <Box
                        sx={{
                            width: "394px",
                            height: "137px",
                            background: (theme) => theme.palette.text.secondary,
                            border: (theme) => `1px solid ${theme.palette.text.primary}`,
                            borderRadius: "8px",
                            display: "flex"
                        }}
                    >
                        <Box sx={{ width: "40px", height: "40px", pt: "7px", pl: "11px" }}>
                            <img
                                loading="eager"
                                style={{ width: "inherit", height: "inherit" }}
                                src={read_outlined}
                                alt="read_outlined"
                            />
                        </Box>
                        <Typography
                            variant="h3"
                            fontFamily="Fixel Display, sans-serif"
                            fontWeight={600}
                            fontSize="22px"
                            lineHeight="24px"
                            textTransform="uppercase"
                            sx={{
                                color: (theme) => theme.palette.background.default,
                                alignContent: "center",
                                p: "7px 15px 7px 20px",
                            }}
                        >
                            Неформальна освіта для молоді
                        </Typography>
                    </Box>
                </Grid>
                <Grid item lg={4} sx={{ display: { xs: "none", lg: "block" } }}>
                    <Box
                        sx={{
                            width: "394px",
                            height: "137px",
                            background: (theme) => theme.palette.text.secondary,
                            border: (theme) => `1px solid ${theme.palette.text.primary}`,
                            borderRadius: "8px",
                            display: "flex"
                        }}
                    >
                        <Box sx={{ width: "40px", height: "40px", pt: "7px", pl: "11px" }}>
                            <img
                                loading="eager"
                                style={{ width: "inherit", height: "inherit" }}
                                src={team_outlined}
                                alt="team_outlined"
                            />
                        </Box>
                        <Typography
                            variant="h3"
                            fontFamily="Fixel Display, sans-serif"
                            fontWeight={600}
                            fontSize="22px"
                            lineHeight="24px"
                            textTransform="uppercase"
                            sx={{
                                color: (theme) => theme.palette.background.default,
                                alignContent: "center",
                                p: "7px 0px 7px 20px",
                            }}
                        >
                            Мистецька діяльність задля розвитку демократичних цінностей українського суспільства
                        </Typography>
                    </Box>
                </Grid>
                {/* xs/md */}
                <Grid item xs={4} md={5} sx={{ display: { xs: "flex", lg: "none" }, justifyContent: "space-between", flexWrap: "wrap", mt: "43px" }}>
                    <Box sx={{ width: { xs: "100%", md: "358px" } }}>
                        <Typography variant="h2" fontFamily="Druk Wide, sans-serif" fontWeight="bold" fontSize={{ xs: "26px", md: "24px" }} lineHeight="38px">
                            Наша діяльність
                        </Typography>
                        <Typography variant="h5" fontFamily="Fixel Display, sans-serif" color="text.secondary" sx={{ mt: "14px" }}>
                            Ми проводимо навчальні сесії та тренінги, спрямовані на підвищення обізнаності про українську культуру, історію, а також на розвиток навичок, необхідних для підтримки та просування українських<br />інтересів у світі. Наші тренінги допомагають учасникам глибше зрозуміти<br />українські реалії та набути знань.
                        </Typography>
                    </Box>
                    <Box sx={{ width: { xs: "100%", md: "372px" }, mt: { xs: "43px", md: "0px" } }}>
                        <Box
                            sx={{
                                width: "inherit",
                                height: "111px",
                                background: (theme) => theme.palette.text.secondary,
                                border: (theme) => `1px solid ${theme.palette.text.primary}`,
                                borderRadius: "8px",
                                display: "flex"
                            }}
                        >
                            <Box sx={{ width: "40px", height: "40px", pt: "7px", pl: "11px" }}>
                                <img
                                    loading="eager"
                                    style={{ width: "inherit", height: "inherit" }}
                                    src={audit_outlined}
                                    alt="audit_outlined"
                                />
                            </Box>
                            <Typography
                                variant="h3"
                                fontFamily="Fixel Display, sans-serif"
                                fontWeight={600}
                                fontSize="18px"
                                lineHeight="24px"
                                textTransform="uppercase"
                                sx={{
                                    color: (theme) => theme.palette.background.default,
                                    alignContent: "center",
                                    p: "7px 1px 7px 22px",
                                }}
                            >
                                Збереження та популяризація української культурної спадщини
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                width: "inherit",
                                height: "126px",
                                background: (theme) => theme.palette.text.secondary,
                                border: (theme) => `1px solid ${theme.palette.text.primary}`,
                                borderRadius: "8px",
                                display: "flex",
                                my: { xs: "18px", md: "14px" }
                            }}
                        >
                            <Box sx={{ width: "40px", height: "40px", pt: "7px", pl: "11px" }}>
                                <img
                                    loading="eager"
                                    style={{ width: "inherit", height: "inherit" }}
                                    src={team_outlined}
                                    alt="team_outlined"
                                />
                            </Box>
                            <Typography
                                variant="h3"
                                fontFamily="Fixel Display, sans-serif"
                                fontWeight={600}
                                fontSize="18px"
                                lineHeight="24px"
                                textTransform="uppercase"
                                sx={{
                                    color: (theme) => theme.palette.background.default,
                                    alignContent: "center",
                                    p: "7px 18px 13px 23px",
                                }}
                            >
                                Мистецька діяльність задля розвитку демократичних цінностей українського суспільства
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                width: "inherit",
                                height: "111px",
                                background: (theme) => theme.palette.text.secondary,
                                border: (theme) => `1px solid ${theme.palette.text.primary}`,
                                borderRadius: "8px",
                                display: "flex"
                            }}
                        >
                            <Box sx={{ width: "40px", height: "40px", pt: "7px", pl: "11px" }}>
                                <img
                                    loading="eager"
                                    style={{ width: "inherit", height: "inherit" }}
                                    src={read_outlined}
                                    alt="read_outlined"
                                />
                            </Box>
                            <Typography
                                variant="h3"
                                fontFamily="Fixel Display, sans-serif"
                                fontWeight={600}
                                fontSize="18px"
                                lineHeight="24px"
                                textTransform="uppercase"
                                sx={{
                                    color: (theme) => theme.palette.background.default,
                                    alignContent: "center",
                                    p: "7px 11px 7px 23px",
                                }}
                            >
                                Неформальна освіта для молоді
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
                {/* Наша звітність */}
                <Reporting />
                {/* Наша команда */}
                <Grid item xs={4} md={5} lg={12} sx={{ mt: { xs: "43px", lg: "94px" } }}>
                    <Typography variant="h2" fontFamily="Druk Wide, sans-serif" fontWeight="bold" fontSize={{ xs: "26px", md: "24px", lg: "36px" }} lineHeight="38px">
                        Наша команда
                    </Typography>
                    <Box sx={{ display: { xs: "flex", md: "none", lg: "flex" }, justifyContent: "space-between", flexWrap: "wrap", alignItems: "center", mt: { xs: "14px", lg: "31px" } }}>
                        <Box sx={{ width: { xs: "350px", lg: "391px" }, height: { xs: "462px", lg: "517px" } }}>
                            <img
                                loading="lazy"
                                style={{ width: "inherit", height: "inherit" }}
                                src={`/assets/backgrounds/team_desktop/1.png`}
                                alt="team_member_1"
                            />
                        </Box>
                        <Box>
                            <Box sx={{ width: { xs: "350px", lg: "391px" }, height: { xs: "462px", lg: "517px" }, my: { xs: "11px", lg: "0px" } }}>
                                <img
                                    loading="lazy"
                                    style={{ width: "inherit", height: "inherit" }}
                                    src={`/assets/backgrounds/team_desktop/2.png`}
                                    alt="team_member_2"
                                />
                            </Box>
                            <LinkRouter underline="always" color="inherit" to="/about-us" sx={{ display: { xs: "none", lg: "flex" }, justifyContent: "center" }}>
                                <Typography variant="h4" fontFamily="Fixel Display" textAlign="center" sx={{ mt: "48px" }}>
                                    Більше...
                                </Typography>
                            </LinkRouter>
                        </Box>
                        <Box sx={{ width: { xs: "350px", lg: "391px" }, height: { xs: "462px", lg: "517px" } }}>
                            <img
                                loading="lazy"
                                style={{ width: "inherit", height: "inherit" }}
                                src={`/assets/backgrounds/team_desktop/3.png`}
                                alt="team_member_3"
                            />
                        </Box>
                        <Box sx={{ width: "350px", display: { xs: "flex", lg: "none" }, justifyContent: "center", mt: "24px" }}>
                            <LinkRouter underline="always" color="inherit" to="/about-us" >
                                <Typography variant="h4" fontFamily="Fixel Display" textAlign="center">
                                    Більше...
                                </Typography>
                            </LinkRouter>
                        </Box>
                    </Box>
                </Grid>
                <Grid item md={5} lg={12} sx={{ display: { xs: "none", md: "block", lg: "none" }, mt: "14px" }}>
                    <TeamCarousel />
                </Grid>
                {/* Хронологія */}
                <Grid item xs={4} md={5} lg={12} sx={{ mt: { xs: "43px", lg: "118px" } }}>
                    <Typography variant="h2" fontFamily="Druk Wide, sans-serif" fontWeight="bold" fontSize={{ md: "24px", lg: "36px" }} lineHeight="38px">
                        Хронологія
                    </Typography>
                </Grid>
                {(isXl || isLg) && <Chronology />}
                {isMd && <ChronologyTablet />}
                {isXs && <ChronologyPhone />}
                {/* Наші партнери */}
                <Grid item xs={4} md={5} lg={12} sx={{ mt: { xs: "43px", lg: "78px" } }}>
                    <Typography variant="h2" fontFamily="Druk Wide, sans-serif" fontWeight="bold" fontSize={{ xs: "26px", md: "24px", lg: "36px" }} lineHeight="38px">
                        Наші партнери
                    </Typography>
                    {(isXl || isLg) && <Box sx={{ mt: "32px", position: "relative" }}>
                        <Swiper
                            modules={[Navigation]}
                            navigation={{
                                nextEl: '.team-next',
                                prevEl: '.team-prev',
                                disabledClass: 'opacity-40'
                            }}
                            slidesPerView={'auto'}
                            slidesPerGroup={1}
                            spaceBetween={24}
                            style={{ marginLeft: "25px", marginRight: "40px", paddingLeft: "0px", paddingRight: "0px" }}
                        >
                            {partners.map((item, index) => {
                                return (
                                    <SwiperSlide key={`partner_${index}`} style={{ width: "auto" }}>
                                        <Box sx={{ height: "130px" }}>
                                            <img
                                                loading="lazy"
                                                style={{ maxWidth: "100%", height: "inherit" }}
                                                src={item}
                                                alt={`partner_${index}`}
                                            />
                                        </Box>
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                        <Box sx={{ width: "100%", position: "absolute", left: "0px", top: "40%", display: "flex", justifyContent: "space-between" }}>
                            <Box className="team-prev">
                                <IconButton disableRipple size="small" sx={{ width: "24px", height: "24px", border: `2px solid ${palette.text.secondary}`, p: "0px", zIndex: 10 }}>
                                    <KeyboardArrowLeft fontSize="inherit" sx={{ width: "inherit", height: "inherit", color: palette.text.secondary }} />
                                </IconButton>
                            </Box>
                            <Box className="team-next">
                                <IconButton disableRipple size="small" sx={{ width: "24px", height: "24px", border: `2px solid ${palette.text.secondary}`, p: "0px", zIndex: 10 }}>
                                    <KeyboardArrowRight fontSize="inherit" sx={{ width: "inherit", height: "inherit", color: palette.text.secondary }} />
                                </IconButton>
                            </Box>
                        </Box>
                    </Box>}
                    {isMd && <Box sx={{ mt: "14px", position: "relative" }}>
                        <Swiper
                            modules={[Navigation]}
                            navigation={{
                                nextEl: '.team-next',
                                prevEl: '.team-prev',
                                disabledClass: 'opacity-40'
                            }}
                            slidesPerView={'auto'}
                            slidesPerGroup={1}
                            spaceBetween={24}
                            style={{ marginLeft: "40px", marginRight: "60px", paddingLeft: "0px", paddingRight: "0px" }}
                        >
                            {partners.map((item, index) => {
                                return (
                                    <SwiperSlide key={`partner_${index}`} style={{ width: "auto" }}>
                                        <Box sx={{ height: "130px" }}>
                                            <img
                                                loading="lazy"
                                                style={{ maxWidth: "100%", height: "inherit" }}
                                                src={item}
                                                alt={`partner_${index}`}
                                            />
                                        </Box>
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                        <Box sx={{ width: "100%", position: "absolute", left: "0px", top: "30%", display: "flex", justifyContent: "space-between" }}>
                            <Box className="team-prev">
                                <IconButton disableRipple size="small" sx={{ width: "40px", height: "40px", border: `2px solid ${palette.text.secondary}`, p: "0px", zIndex: 10 }}>
                                    <KeyboardArrowLeft fontSize="inherit" sx={{ width: "inherit", height: "inherit", color: palette.text.secondary }} />
                                </IconButton>
                            </Box>
                            <Box className="team-next">
                                <IconButton disableRipple size="small" sx={{ width: "40px", height: "40px", border: `2px solid ${palette.text.secondary}`, p: "0px", zIndex: 10 }}>
                                    <KeyboardArrowRight fontSize="inherit" sx={{ width: "inherit", height: "inherit", color: palette.text.secondary }} />
                                </IconButton>
                            </Box>
                        </Box>
                    </Box>}
                    {isXs && <Box sx={{ mt: "14px", position: "relative" }}>
                        <Swiper
                            modules={[Navigation]}
                            navigation={{
                                nextEl: '.team-next',
                                prevEl: '.team-prev',
                                disabledClass: 'opacity-40'
                            }}
                            slidesPerView={'auto'}
                            slidesPerGroup={1}
                            spaceBetween={24}
                            style={{ marginLeft: "30px", marginRight: "50px", paddingLeft: "0px", paddingRight: "0px" }}
                        >
                            {partners.map((item, index) => (
                                <SwiperSlide key={`partner_${index}`} style={{ width: "auto" }}>
                                    <Box sx={{ height: "72px" }}>
                                        <img
                                            loading="lazy"
                                            style={{ maxWidth: "100%", height: "inherit" }}
                                            src={item}
                                            alt={`partner_${index}`}
                                        />
                                    </Box>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <Box sx={{ width: "100%", position: "absolute", left: "0px", top: "30%", display: "flex", justifyContent: "space-between" }}>
                            <Box className="team-prev">
                                <IconButton disableRipple size="small" sx={{ width: "24px", height: "24px", border: `2px solid ${palette.text.secondary}`, p: "0px", zIndex: 10 }}>
                                    <KeyboardArrowLeft fontSize="inherit" sx={{ width: "inherit", height: "inherit", color: palette.text.secondary }} />
                                </IconButton>
                            </Box>
                            <Box className="team-next">
                                <IconButton disableRipple size="small" sx={{ width: "24px", height: "24px", border: `2px solid ${palette.text.secondary}`, p: "0px", zIndex: 10 }}>
                                    <KeyboardArrowRight fontSize="inherit" sx={{ width: "inherit", height: "inherit", color: palette.text.secondary }} />
                                </IconButton>
                            </Box>
                        </Box>
                    </Box>}
                </Grid>
                {/* Контакти */}
                <Contacts />
            </Grid >
        </>
    )
}

export default HomePage